module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/alipay-de4d494a668af95c5d7f84cb510718d0.svg";